var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFabCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 62.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M63,31.48A31.51,31.51,0,0,1,14.44,58a32.1,32.1,0,0,1-8.07-7.48A31.5,31.5,0,1,1,63,31.48Z",
    style: {
      fill: "#ff69b3"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.08,
    y1: 16.73,
    x2: 46.37,
    y2: 46.23,
    style: {
      fill: "none",
      stroke: "#ededed",
      strokeLinecap: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.37,
    y1: 16.48,
    x2: 16.72,
    y2: 46.48,
    style: {
      fill: "none",
      stroke: "#ededed",
      strokeLinecap: "round",
      strokeWidth: 4
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabCloseIcon);
export default __webpack_public_path__ + "static/media/fab-close-icon.8803b39c63e20805a99837037daaad1c.svg";
export { ForwardRef as ReactComponent };